package fyi.moko.hotpl.domain.model

/**
 * A search candidate returned by a place autocomplete provider (e.g. Google Places API).
 *
 * This is intentionally a lightweight DTO. It only carries enough information to render a
 * prediction row and to request full details later via [PlaceSearchProvider.fetchPlaceDetails].
 */
data class SearchPrediction(
    /** Provider-specific unique place identifier (Google Place ID). */
    val placeId: String,
    /** Primary place name, e.g. "Blue Bottle Coffee". */
    val primaryText: String,
    /** Secondary descriptive text, e.g. "Wilshire Blvd, Los Angeles, CA". */
    val secondaryText: String,
    /**
     * Straight-line metres from the searching user, or null when the search ran without a
     * known location (or against a destination area instead). Google supplies this itself
     * once the request carries an `origin`; Nominatim's is computed from the coordinates it
     * returns. Null sorts last — an unknown distance is not a near one.
     */
    val distanceMeters: Int? = null,
)
